/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { OperationType } from 'relay-runtime';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type HelpCenterSettingsCreateArticleAppEntryPointComponent = EntryPointComponent<
	Record<string, OperationType>,
	// oxlint-disable-next-line typescript/no-explicit-any
	Record<string, EntryPoint<any, any> | undefined>,
	{},
	{} | null
>;

export const HelpCenterSettingsCreateArticleAppEntryPoint: EntryPoint<
	HelpCenterSettingsCreateArticleAppEntryPointComponent,
	{}
> = createEntryPoint({
	root: JSResourceForUserVisible<HelpCenterSettingsCreateArticleAppEntryPointComponent>(
		/* webpackChunkName: "async-help-center-setting-create-article" */ './HelpCenterSettingsCreateArticleComponent.tsx',
		{
			entryFsSsrLiftImportToModule: true,
		},
	),
	getPreloadProps: () => {
		return {};
	},
});
